import { useApiList } from "@/queries/base/useApiList";

/**
 * Fetches all Asset Details.
 * GET /asset_detail
 */
export function useAssetDetails(deps = []) {
  return useApiList("/asset_detail", [deps]);
}
